//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _ConfirmationDialog from './ConfirmationDialog';
import _ProgressDialog from './ProgressDialog';
import _SimpleDialog from './SimpleDialog';
import _SyncDialog from './SyncDialog';
import * as _styles from './styles';
export const ConfirmationDialog = _ConfirmationDialog;
export const ProgressDialog = _ProgressDialog;
export const SimpleDialog = _SimpleDialog;
export const SyncDialog = _SyncDialog;
export const styles = _styles;
export default {ConfirmationDialog, ProgressDialog, SimpleDialog, SyncDialog, styles};

